import * as Decimal from 'decimal.js';
import NumberHelper from './../../../Shared/Helpers/numberHelper';

export default class MoneyTransferAmountHelper
{
   static roundSenderAmount (senderAmount, senderCurrency) {
       let sentAmountDec = new Decimal(NumberHelper.toInvariantCultureNumberString(senderAmount));
       if (senderCurrency === "CLP") {
            sentAmountDec = Math.round(sentAmountDec, 0);
            return sentAmountDec.toFixed(0);
        }
        return sentAmountDec.toFixed(2);
    }

    static roundReceiverAmount (receiverAmount, receiverCurrency) {
        // It should be synchronized with RoundingSettings._zeroRoundingReceiverCurrencies
        const zeroRoundingReceiverCurrencies = ["CUP", "CLP", "MLC"];

        let receiverAmountDec = new Decimal(NumberHelper.toInvariantCultureNumberString(receiverAmount));
        const country = jQuery(".receiverAmount .dropdown").data("country");

        if (country === "Cuba" || zeroRoundingReceiverCurrencies.indexOf(receiverCurrency) > -1 || window.banking.productSkuByPageLoading === 'banking_cuba_cash_delivery_usd') {
            receiverAmountDec = Math.round(receiverAmountDec, 0);
            return receiverAmountDec.toFixed(0);
        }

        return receiverAmountDec.toFixed(2);
    }
}